// Silicon Valley Orthodontics + Redwood Shores Orthodontics (Dr. Wu, Bay Area CA)
// - one catalog, two offices. Backend: bondLocations.ts SILICON_VALLEY_PALO_ALTO /
// SILICON_VALLEY_REDWOOD_SHORES (brandId "silicon_valley", catalog 893c08c7, Edge
// loc 4/5, procedure 388, DB 357). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 357). English-only.
import type { BrandConfig } from "./types";

export const siliconValley: BrandConfig = {
  slug: "silicon-valley",
  brandId: "silicon_valley",
  brandName: "Silicon Valley Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/b4bb14cc-254c-4063-90ec-672bdda43e51.png",
  phone: "(650) 322-0288",
  phoneHref: "tel:+16503220288",
  theme: { primary: "#3459C9", primaryDark: "#1C2740" },
  locales: ["en"],
  locations: {
    SILICON_VALLEY_PALO_ALTO: {
      id: "SILICON_VALLEY_PALO_ALTO",
      name: "Palo Alto",
      addressLines: ["1865 El Camino Real", "Palo Alto, CA 94306"],
      mapsUrl: "https://maps.google.com/?q=1865+El+Camino+Real+Palo+Alto+CA+94306",
      timezone: "America/Los_Angeles",
    },
    SILICON_VALLEY_REDWOOD_SHORES: {
      id: "SILICON_VALLEY_REDWOOD_SHORES",
      name: "Redwood Shores",
      addressLines: ["358 Marine Parkway, Suite 200", "Redwood City, CA 94065"],
      mapsUrl: "https://maps.google.com/?q=358+Marine+Parkway+Suite+200+Redwood+City+CA+94065",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: {
    PALO_ALTO: "SILICON_VALLEY_PALO_ALTO",
    REDWOOD_SHORES: "SILICON_VALLEY_REDWOOD_SHORES",
    REDWOOD_CITY: "SILICON_VALLEY_REDWOOD_SHORES",
  },
};
